import { useState } from 'react';
import { createClient } from '@supabase/supabase-js';

const supabase = createClient(
  'https://bopvbykhekvrayihgfqm.supabase.co',
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJvcHZieWtoZWt2cmF5aWhnZnFtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQ1ODcyOTgsImV4cCI6MjA2MDE2MzI5OH0.PaJUSFBblBC7b74NrvDMNMZNMiLczHItdfJbMWCe5Lw'
);

export default function RegistroCreador() {
  const [form, setForm] = useState({
    nombre_completo: '',
    email: '',
    password: '',
    edad: '',
    color_favorito: '',
    universo_favorito: '',
    prompt_creativo: '',
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const {
      nombre_completo,
      email,
      password,
      edad,
      color_favorito,
      universo_favorito,
      prompt_creativo
    } = form;

    const { data, error } = await supabase.from('creadores').insert([
      {
        nombre_completo,
        email,
        password_hash: password,
        edad: parseInt(edad),
        color_favorito,
        universo_favorito,
        prompt_creativo,
        url: nombre_completo.toLowerCase().replace(/\s+/g, ''),
        foto_url: '',
        biografia: '',
      },
    ]);

    if (error) {
      console.error('Error al registrar:', error);
      alert('Hubo un error. Revisa la consola.');
    } else {
      alert('¡Registro exitoso! Ya tienes tu cuenta en Nubbi.');
    }
  };

  return (
    <div className="p-4 max-w-lg mx-auto">
      <h2 className="text-2xl font-bold mb-4">Register your Nubbi Creator Profile</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <input name="nombre_completo" placeholder="Full name" onChange={handleChange} className="w-full border p-2" required />
        <input name="email" type="email" placeholder="Email" onChange={handleChange} className="w-full border p-2" required />
        <input name="password" type="password" placeholder="Password" onChange={handleChange} className="w-full border p-2" required />
        <input name="edad" type="number" placeholder="Age" onChange={handleChange} className="w-full border p-2" required />

        <select name="color_favorito" onChange={handleChange} className="w-full border p-2" required>
          <option value="">Choose your favorite color</option>
          <option value="Blue">Blue</option>
          <option value="Pink">Pink</option>
          <option value="Green">Green</option>
          <option value="Orange">Orange</option>
          <option value="Purple">Purple</option>
        </select>

        <select name="universo_favorito" onChange={handleChange} className="w-full border p-2" required>
          <option value="">Select your favorite Nubbi universe</option>
          <option value="MEX">Mexotics</option>
          <option value="BRK">Barklings</option>
          <option value="MOJ">InMojis</option>
          <option value="SIN">Sinterra</option>
          <option value="PLA">Plantix Crew</option>
          <option value="PAT">Patriot Stripes</option>
          <option value="MIN">Mineralia</option>
          <option value="KAZ">Kanzu World</option>
          <option value="ICE">Nox Vinter (ICE)</option>
        </select>

        <textarea name="prompt_creativo" placeholder="Imagine a new Nubbi creature for the world. What universe would it belong to? Describe it as best as you can."
          onChange={handleChange} className="w-full border p-2 h-24" required />

        <button type="submit" className="bg-blue-600 text-white py-2 px-4 rounded">Register</button>
      </form>
    </div>
  );
}